export const TransferType = {
  ownAccount: 'ownAccount',
  gift: 'gift',
  inheritance: 'inheritance',
  other: 'other'
};

export const TransferOptions = [
  {
    infoTextKey: 'app.transferState.type.ownAccount.info',
    label: 'app.transferState.type.ownAccount.label',
    value: TransferType.ownAccount
  },
  {
    infoTextKey: 'app.transferState.type.gift.info',
    label: 'app.transferState.type.gift.label',
    value: TransferType.gift
  },
  {
    infoTextKey: 'app.transferState.type.inheritance.info',
    label: 'app.transferState.type.inheritance.label',
    value: TransferType.inheritance
  },
  {
    infoTextKey: 'app.transferState.type.other.info',
    label: 'app.transferState.type.other.label',
    value: TransferType.other
  }
];



// WEBPACK FOOTER //
// ./src/app/components/transfer/transfer.constants.js